import strapDB from './strapDBFunctions';
export default strapDB;
